export default "__VITE_ASSET__DstRfIj1__"